import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { compose } from 'recompose';
import { Route, Switch, withRouter } from 'react-router-dom';

// Material UI
import withStyles from '@material-ui/core/styles/withStyles';

// Local
import Assets from './Assets';
import Experiences from './Experiences';
import AddAsset from './AddAsset';
import Main from './Main';
import ModalRoot from 'components/Modal/ModalRoot';

import style from './Mam2.module.css';

const styles = theme => ({
  content: {
    flexGrow: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  titleContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  mainContainer: {
    // display: 'flex',
    // flexWrap: 'wrap',
    backgroundColor: '#350',
  },
  leftContainer: {
    flexGrow: 3,
    paddingRight: 5,
    backgroundColor: '#930',
  },
  rightContainer: {
    flexGrow: 1,
    paddingLeft: 5,
    backgroundColor: '#750',
  },
  paper: {
    padding: 10,
  },
  libraryContainer: {
    height: '40vh',
  },
  paperTopPadding: {
    marginTop: 10,
  },
  title: {
    ...theme.Typography,
    color: '#044591',
    paddingBottom: theme.spacing(),
  },
  campaignLeftContainer: {
    backgroundColor: '#ff0',
  },
  campaignRightContainer: {
    backgroundColor: '#f00',
  },
});

export class Mam2 extends PureComponent {
  handleAddFile = file => {
    this.props.createEncoding(this.props.match.params.id, file);
  };

  handleAddAssetClick = () => {
    const { match, history } = this.props;
    const url = `${match.url}/assets/add`;
    console.log('URL', url);
    // return <Redirect to={url} />;

    history.push(`${match.url}/assets/add`);
  };

  render() {
    const { classes, match } = this.props;

    // console.log('match', match);
    // console.log('history', history);

    const assetAddUrl = `${match.url}/assets/add`;
    // console.log('assetAddUrl', assetAddUrl);

    return (
      <div className={classnames(style.grid, classes.content)}>
        <div className={classnames(style.main, 'shadow rounded p-4 bg-white')}>
          <Switch location={this.props.location}>
            <Route exact path={assetAddUrl} component={AddAsset} />
            <Route component={Main} />
          </Switch>
        </div>
        <div className={classnames(style.exp, 'shadow rounded bg-white')}>
          <Experiences />
        </div>
        <div className={classnames(style.assets, 'shadow rounded bg-white')}>
          <Assets handleAddAssetClick={this.handleAddAssetClick} />
        </div>
        <ModalRoot />
      </div>
    );
  }
}

Mam2.propTypes = {
  auth: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  messages: PropTypes.array,
};

const enhance = compose(withStyles(styles), withRouter);

export default enhance(Mam2);
